<template>
  <div id="user-edit-tab-info">
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <vs-avatar
            :src="
              data_local.userdata.avatar
                ? `https://selfie.cash/avatar/${data_local.userdata.avatar}`
                : require('@/assets/images/avatar.png')"
            size="150px"
            class="border-2 border-white border-solid -m-1"
          ></vs-avatar>
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        
        <vs-input
          class="w-full mt-4"
          label="* Name"
          v-model="name"
          v-validate="'required'"
          name="firstname"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>

        
        <vs-input
          type="email"
          class="w-full mt-4"
          label="* Email"
          v-model="data_local.userdata.email"
          v-validate="'required'"
          name="email"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first("email")
        }}</span>

        <vs-input
          class="w-full mt-4"
          label="Phone Number"
          v-model="phone"
          v-validate="'required'"
          name="firstname"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>


        <vs-input
          class="w-full mt-4"
          label="City"
          v-model="countrytext"
          v-validate="'required'"
          name="firstname"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>

        
        <vs-input
          class="w-full mt-4"
          label="Address"
          v-model="address"
          v-validate="'required'"
          name="firstname"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full" style="margin-bottom:100px">
        

        <vs-input
          class="w-full mt-4"
          label="UserID"
          v-model="data_local.userdata.id"
          v-validate="'required'"
          name="userid"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('username')">{{
          errors.first("username")
        }}</span>


        <vs-input
          class="w-full mt-4"
          label="Date of Birth"
          v-model="data_local.userdata.birthday"
          v-validate="'required'"
          name="Birthday"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('username')">{{
          errors.first("username")
        }}</span>

        <vs-input
          class="w-full mt-4"
          label="Website"
          v-model="website"
          v-validate="'required'"
          name="email"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first("email")
        }}</span>

        
        <vs-input
          class="w-full mt-4"
          label="Post code"
          v-model="postcode"
          v-validate="'required'"
          name="email"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first("email")
        }}</span>
        
      </div>
      
    </div>

    <!-- Save & Reset Button -->
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: "",
      countrytext: "",
      phone: "",
      address: "",
      website: "",
      postcode: "",
      data_local: JSON.parse(JSON.stringify(this.userData)),

      departOptions: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" }
      ],
      roleOptions: [
        { label: "SuperAdmin", value: "superadmin" },
        { label: "president", value: "president" },
        { label: "Officer", value: "officer" },
        { label: "Researcher", value: "researcher" },
        { label: "Engineer", value: "engineer" },
      ],
      companyOptions: [
        { label: "7*9", value: "7*9" },
        { label: "3*9", value: "3*9" },
        { label: "5*4", value: "5*4" },
        { label: "8*2", value: "8*2" },
        { label: "AI", value: "ai" },
        { label: "Net", value: "net" },
      ],
      teamOptions: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
      ],
    };
  },
  computed: {
    status_local: {
      get() {
        const val = this.data_local.userdata.status === true ? "Approved" : "Pending";
        return { label: this.capitalize(val), value: val };
      },
      set(obj) {
        this.data_local.userdata.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.userdata.role),
          value: this.data_local.userdata.role,
        };
      },
      set(obj) {
        this.data_local.userdata.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes() {
      /* eslint-disable */
//      if (!this.validateForm) return;

      const payload = {
        userDetails: {
          _id: this.data_local.userdata._id,
          firstname: this.data_local.userdata.firstname,
          lastname: this.data_local.userdata.lastname,
          userId: this.data_local.userdata.id,
          role: this.data_local.userdata.role,
          birthday: this.data_local.userdata.birthday,
          email: this.data_local.userdata.email,
          country: this.data_local.userdata.country
        },
        file: this.data_local.userdata.avatar,
      };
      // sending file to the backendthis.$store
      this.$store
        .dispatch("userManagement/updateUser", payload)
        .then((res) => {
          this.reset_data();
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "User Upload Failed!",
            text: res.message,
          });
          console.error(err);
        });

      // Here will go your API call for updating data
      // You can get data in "this.data_local.userdata"

      /* eslint-enable */
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },
    update_avatar(e) {
      let files = e.target.files || e.dataTransfer.files;
      this.createImage(files[0]);
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      this.data_local.userdata.avatar = file;
      reader.onload = (e) => {
        document.getElementsByClassName("avatar_image")[0].src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeAvatar() {
      this.data_local.userdata.avatar = ""
      document.getElementsByClassName(
        "avatar_image"
      )[0].src = require("@/assets/images/avatar.png");
    },
  },
  created() {
    console.log(this.data_local)
    this.name = this.data_local.userdata.firstname + ' ' + this.data_local.userdata.lastname
    this.countrytext = (this.data_local.userdata.country == 1) ? "Netherlands" : (this.data_local.userdata.country == 2) ? "United States":"Ukriane"
  }
};
</script>
